import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tt.css';

function GeminiXBot() {
  const navigate = useNavigate();

  // Media placeholders – place actual files in `/public` and keep or rename these.
  const dashboardImg = process.env.PUBLIC_URL + '/x-bot-dashboard.png';
  const schedulerImg = process.env.PUBLIC_URL + '/x-bot-scheduler.png';
  const topicsImg = process.env.PUBLIC_URL + '/x-bot-topics.png';
  const demoVideo = process.env.PUBLIC_URL + '/X-Bot-auto-poster.mp4';

  const [modalImage, setModalImage] = useState(null);

  const openModal = (image) => setModalImage(image);
  const closeModal = () => setModalImage(null);

  return (
    <div className="TripTunes">
      <div className="middle-column" style={{ fontSize: '1.1rem', lineHeight: 1.65 }}>
        <h1>X-Bot with Gemini API</h1>
        <h3>What is this project?</h3>
        <p>
          This is a fully automated posting system that runs a real live X (formerly Twitter)
          account. Posts are generated by Google&apos;s Gemini and are published on a schedule at random
          times within a timeframe you set.
        </p>

        <img
          src={dashboardImg}
          alt="X-Bot dashboard"
          onClick={() => openModal(dashboardImg)}
        />

        <h3>How scheduling works</h3>
        <p>
          From the UI, you set a timeframe and how many posts should be made per day. The scheduler
          picks random times inside that window, then continuously checks (every second) whether it&apos;s
          time to post.
        </p>

        <img
          src={schedulerImg}
          alt="X-Bot scheduler tab"
          onClick={() => openModal(schedulerImg)}
        />

        <h3>Topic system (xbot.db)</h3>
        <p>
          When a scheduled time is reached, the bot selects a topic from <b>xbot.db</b>. Topics can be
          added or deleted, and each topic can be disabled/enabled directly from the UI.
        </p>

        <img 
        src={topicsImg} 
        alt="X-Bot topics manager" 
        onClick={() => openModal(topicsImg)} 
        />

        <h3>Gemini tweet generation</h3>
        <p>
          On the server side, the selected topic is combined with a pre-set prompt and sent to a
          text-based Gemini model. We currently use <b>gemini-3.1-flash-lite</b> because it has a higher
          free-tier request limit. Gemini returns a tweet draft, which we then parse and format
          correctly before publishing.
        </p>

        <h3>Two execution modes for posting on X</h3>
        <p>
          Originally, posts were published using the X API create-post endpoint. Since X removed its
          free tier and most API calls now require payment, the project also supports a browser
          automation fallback.
        </p>
        <p>
          In the automation mode, we use <b>Playwright</b> to open a Chrome tab, navigate to{' '}
          <b>x.com</b>, type the generated post, and publish it, like a real human would, but driven by
          the bot (shown in the demo video below).
        </p>

        <h3>Live demo</h3>


        <video
          src={demoVideo}
          style={{ width: '100%', borderRadius: 10, marginTop: 10 }}
          autoPlay
          muted
          loop
          playsInline
        />

        <p>
          This video shows the end-to-end flow: scheduler triggers → Gemini generates → post is
          published on X (via Playwright automation).
        </p>

        <br />
        <br />
        <button onClick={() => navigate('/')}>Back to Homepage</button>
        <br />
        <br />
      </div>

      {modalImage && (
        <div className="modal" onClick={closeModal}>
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <img className="modal-content" src={modalImage} alt="Modal" />
        </div>
      )}
    </div>
  );
}

export default GeminiXBot;
